import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.creator-warning-status-form-modal': {},
  '.creator-warning-status-form-modal': {
    '&__btn-wrapper': {
      gap: theme.space[3],
      padding: `${theme.space[4]} 0`,
      justifyContent: 'end',
    },
    '&__text': {
      margin: `12px 0 12px`,
      fontSize: theme.fontSizes[3],
      color: COLORS.NEUTRAL800,
    },
    '&__textarea': {
      marginBottom: theme.space[6],
    },
  },
});
